// ============================================================
// 路由实例的运行时全局引用
// 用途：让 shared 层（如 request 拦截器）在不直接 import 各端 router 的前提下
// 也能做 router.push('/login') / router.removeRoute(name) 等操作
//
// 各端 main.ts 启动时调用 registerRouter(router) 注册自己即可
// ============================================================
import type { Router } from "vue-router";

let _router: Router | null = null;

export function registerRouter(router: Router): void {
    _router = router;
}

export function getRouter(): Router | null {
    return _router;
}
